import moment from "moment";

export class Fixtures {
  constructor({ animate, preview, update, animateOff }) {
    this.onAir = false;
    this.sendAnimate = animate;
    this.sendAnimateOff = animateOff;
    this.sendPreview = preview;
    this.sendUpdate = update;
    this.name = "Fixtures";
    this.scene = "Fixtures";
    this.data = [];
    this.page = 1;
  }

  preview({ options }) {
    if (!options.page) {
      this.page = 1;
    }
    this.options = options;
    this.onAir = false;

    this.data = [];

    this.data.push({
      name: "Page",
      value: { text: this.page },
    });
    this.data.push({
      name: "Competition",
      value: { text: options.game?.competition?.name || "" },
    });
    this.data.push({
      name: "Competition Colour",
      value: { colour: options.game?.competition?.colour || "" },
    });
    this.data.push({
      name: "Competition Badge",
      value: { image: "${user}" + options.game?.competition?.badge || "" },
    });
    options.fixtures = JSON.parse(JSON.stringify(options?.fixtures))?.sort(
      (a, b) => {
        return moment(a?.time, "HH:mmZ") - moment(b?.time, "HH:mmZ");
      }
    );
    options.fixtures = options?.fixtures?.sort((a, b) => {
      let a_date = moment(a.date + " " + a.time);
      let b_date = moment(b.date + " " + b.time);
      // Else go to the 2nd item
      if (a_date < b_date) {
        return -1;
      } else if (a_date > b_date) {
        return 1;
      } else {
        // nothing to split them
        if (a?.home_team?.name < b?.home_team?.name) {
          return -1;
        }
        if (a?.home_team?.name > b?.home_team?.name) {
          return 1;
        }
        return 0;
      }
    });
    new Array(36)?.fill(1)?.map((_, index) => {
      let game = options?.fixtures?.[index];

      let row = index + 1;

      

      this.data.push({
        name: "Game " + row + " Home Team Short Name",
        value: { text: game?.home_team?.short_name || "" },
      });
      this.data.push({
        name: "Game " + row + " Home Team Name",
        value: { text: game?.home_team?.name || "" },
      });
      this.data.push({
        name: "Game " + row + " Home Team Badge",
        value: { image: "${user}" + game?.home_team?.variables?.badge || "" },
      });

      this.data.push({
        name: "Game " + row + " Home Team Score",
        value: { text: game?.home_scorers?.length || "0" },
      });

      this.data.push({
        name: "Game " + row + " Away Team Name",
        value: { text: game?.away_team?.name || "" },
      });

      this.data.push({
        name: "Game " + row + " Away Team Short Name",
        value: { text: game?.away_team?.short_name || "" },
      });

      this.data.push({
        name: "Game " + row + " Away Team Badge",
        value: { image: "${user}" + game?.away_team?.variables?.badge || "" },
      });

      this.data.push({
        name: "Game " + row + " Away Team Score",
        value: { text: game?.away_scorers?.length || "0" },
      });

      this.data.push({
        name: "Game " + row + " Kick Off",
        value: {
          // text: moment(game?.time, "HH:mmZ")?.format("HH:mm") || "",
          text: moment(`${game?.date} ${game?.time}`, "YYYY-MM-DD HH:mmZ").format("HH:mm")|| "",
        },
      });

      this.data.push({
        name: "Game " + row + " Date",
        value: { text: game?.date || "" },
      });

      this.data.push({
        name: "Game " + row + " Week",
        value: { text: game?.week || "" },
      });

      let period_1 = game?.opta_periods?.find((p) => p.id === 1);
      let period_2 = game?.opta_periods?.find((p) => p.id === 2);

      this.data.push({
        name: "Game " + row + " Status",
        value: {
          text:
            game?.opta_status === "Played"
              ? "result"
              : game?.opta_status === "Postponed"
              ? "postponed"
              : game?.opta_status === "Suspended"
              ? "suspended"
              : (!period_2 || !period_2.start) && period_1?.end
              ? "halftime"
              : period_1 && period_1.start
              ? "started"
              : "notstarted",
        },
      });

      let period_status = ""; 

      if (((parseInt(game?.opta_scores?.et1?.home) + parseInt(game?.opta_scores?.et2?.home) >= 0)
      || (parseInt(game?.opta_scores?.et1?.away) + parseInt(game?.opta_scores?.et2?.away) >= 0))
    && game?.opta_status !== "Playing") {
      if ((parseInt(game?.opta_scores?.pen?.home) + parseInt(game?.opta_scores?.pen?.away) > 0)) {
        period_status = "P";
     } else {
        period_status = "AET";
    }
      }
     else if (game?.opta_status === "Playing" && !period_status) {
        period_status = "L";
      }
     else {
        period_status = "";
      }

      this.data.push({
        name: "Game " + row + " Live Status",
        value: { text: period_status },
      });
      this.data.push({
        name: "Game " + row + " Home Team Pen Score",
        value: { text: game?.opta_scores?.pen ?  game?.opta_scores?.pen?.home || "0" : '' },
      });
      this.data.push({
        name: "Game " + row + " Away Team Pen Score",
        value: { text: game?.opta_scores?.pen ?  game?.opta_scores?.pen?.away || "0" : '' },
      });
    });

    this.sendPreview(this.scene, 500, this.data, "IN");
  }
  animate({ options }) {
    this.page++;
    this.options.page = this.page;
    this.onAir = true;
    this.sendAnimate(this.scene, this.data);
    this.preview({ options: this.options });
  }
  animateOff({ options }) {
    this.page = 1;
    this.onAir = false;
    this.sendAnimateOff(this.scene, []);
  }
}
